<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="job-cta-list-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <b-col cols="12">
                        <div class="header">
                            <h2
                                class="title h4"
                                v-test:title
                            >
                                {{ title }}
                            </h2>
                            <p
                                class="description"
                                v-test:description
                            >
                                {{ description }}
                            </p>
                        </div>

                        <base-carousel
                            :breakpoints="carouselBreakpoints"
                            navigation
                            :always-show-navigation="showNavigationButtons"
                        >
                            <job-cta-card
                                v-for="(job, i) in jobCtas"
                                :slot="`slot_${ i }`"
                                :key="`slot_${ i }`"
                                :image="job.image"
                                :title="job.title"
                                :text="job.text"
                                :button-text="job.buttonText"
                                :button-link="job.buttonLink"
                            />
                        </base-carousel>

                        <div class="footer">
                            <b-button
                                variant="primary"
                                :href="allJobsLink"
                                target="_blank"
                                rel="noopener"
                                class="all-job-btn"
                                v-test:allJobsBtn
                            >
                                {{ allJobsText }}
                            </b-button>
                        </div>

                    </b-col>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import JobCtaCard from '../../molecules/JobCtaCard/JobCtaCard';
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';

    export default {
        name: 'job-cta-list-section',

        components: { BaseCarousel, JobCtaCard },

        props: {
            title: {
                type: String,
                required: true,
            },

            description: {
                type: String,
                required: true,
            },

            jobCtas: {
                type: Array,
                required: true,
            },

            allJobsLink: {
                type: String,
                required: true,
            },

            allJobsText: {
                type: String,
                required: true,
            },

            showNavigationButtons: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * Return the carousel breakpoints.
             *
             * @returns {object}
             */
            carouselBreakpoints() {
                return {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 1.75,
                    },
                    768: {
                        slidesPerView: 2.2,
                    },
                    992: {
                        slidesPerView: 3.2,
                    },
                    1377: {
                        slidesPerView: 4,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    $slide-padding: 5px;

    .job-cta-list-section {
        padding: 34px 0;

        @include media-breakpoint-up(md) {
            padding: 64px 0;
        }
    }

    .header {
        margin-bottom: 16px;
        padding: 0 25px;
    }

    .title {
        font-weight: bold;
        text-align: center;
        font-size: rem(40px);
        line-height: rem(52px);
    }

    .description {
        max-width: 640px;
        text-align: center;
        margin: 0 auto;
        font-weight: 300;
        letter-spacing: 0.05em;
        color: secondary-palette(4);
        @include media-breakpoint-up(md) {
            font-size: rem(20px);
            line-height: rem(28px);
        }
    }

    ::v-deep .swiper-slide {
        padding: $slide-padding;
        height: auto;
    }

    .job-cta-card {
        height: 100%;
    }

    .footer {
        display: flex;
        justify-content: center;
    }

    .base-carousel {
        margin-bottom: 30px;
        margin-left: -$slide-padding;
        margin-right: -$slide-padding;

        @include media-breakpoint-up(md) {
            margin-bottom: 40px;
        }
    }

    .all-job-btn {
        min-width: 256px;
    }
</style>
